import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "form"]

  connect() {
    this.timeout = null
    // Autofocus the input on page load
    if (this.hasInputTarget) {
      this.inputTarget.focus()
    }
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  search() {
    // Debounce: wait 300ms after user stops typing
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.formTarget.requestSubmit()
    }, 300)
  }

  clear() {
    if (this.hasInputTarget) {
      this.inputTarget.value = ""
      this.inputTarget.focus()
      // Submit the form to show default state (recent searches, categories)
      this.formTarget.requestSubmit()
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  close() {
    // Navigate back or to the previous page
    if (window.history.length > 1) {
      window.history.back()
    } else {
      window.location.href = "/"
    }
  }
}
